export const FLASHCARDS_MEDIA_BUCKET_NAME = 'flashcards-media'

export interface FlashcardsMediaScope {
  workspaceId: string
  pageId: string
}

export interface FlashcardsMediaUser {
  id: string
  authorizePath?: (path: string, minimumLevel: number) => Promise<boolean>
  /** Request-local levels, keyed by immutable workspace/page coordinates. */
  pageLevels?: Readonly<Record<string, number>>
}

export const FLASHCARDS_GENAI_CACHE_USER_ID = 'flashcards-genai-cache'

export function getFlashcardsMediaDir(scope: FlashcardsMediaScope): string {
  return `workspaces/${scope.workspaceId}/assets/${scope.pageId}`
}

export function getFlashcardsMediaFilePath(scope: FlashcardsMediaScope, fileName: string): string {
  return `${getFlashcardsMediaDir(scope)}/${fileName}`
}

/** Writes require Edit; reads explicitly request View. */
export function canAccessFlashcardsMediaPath(path: string, user: FlashcardsMediaUser, minimumLevel = 2): boolean {
  if (path.startsWith('genai/')) return user.id === FLASHCARDS_GENAI_CACHE_USER_ID
  const parts = path.split('/')
  if (parts.length < 5 || parts[0] !== 'workspaces' || parts[2] !== 'assets') return false
  if (parts.some(part => !part || part === '.' || part === '..' || /[%\\]/u.test(part) || Array.from(part).some(character => (character.codePointAt(0) ?? 0) < 32))) return false
  const workspaceId = parts[1]
  const pageId = parts[3]
  if (!workspaceId || !pageId) return false
  return (user.pageLevels?.[`${workspaceId}/${pageId}`] ?? 0) >= minimumLevel
}
